export const noteConstant = {

    NOTE_LIST_REQUEST: 'USERS_NOTE_LIST_REQUEST',
    NOTE_LIST_SUCCESS: 'USERS_NOTE_LIST_SUCCESS',
    NOTE_LIST_FAILURE: 'USERS_NOTE_LIST_FAILURE',
    NOTE_LIST_SHOW : 'USERS_NOTE_LIST_SHOW',

    NOTES_DELETE_SUCCESS:'NOTES_DELETE_SUCCESS'

   
    
}


// WEBPACK FOOTER //
// ./src/store/constants/note.constant.js